import { Link } from "react-router-dom";
import snowflake from "../../../assets/images/svg/snowflake.svg";
import statergicplan from "../../../assets/images/svg/stergicplan.svg";
import operationalplanning from "../../../assets/images/svg/operationalplan.svg";
import jeopradyplan from "../../../assets/images/svg/jeopradyplan.svg";
import routemap from "../../../assets/images/svg/routemap.svg";
import scenariomodel from "../../../assets/images/svg/scenariomodel.svg";
import capacityplanning from "../../../assets/images/svg/capacity-planning-g.svg";
import strategicplanning from "../../../assets/images/svg/strategic-planning-g.svg";
import operationalplanningG from "../../../assets/images/svg/operational-planning-g.svg";
import jeomanagement from "../../../assets/images/svg/jeo-management-g.svg";
import routeplanning from "../../../assets/images/svg/route-planning-g.svg";
import scenarioplanning from "../../../assets/images/svg/scenario-planning-g.svg";
import { useState } from "react";
import { Button } from "main/components/ui-components/Button";
interface imagesData {
  path: string;
  greenIcon: string;
  title: string;
  subtitle: string;
  to: string;
}
const ImagesData: imagesData[] = [
  {
    path: snowflake,
    greenIcon: capacityplanning,
    title: "Capacity Planning",
    subtitle: "Unlock the power of forecasting.",
    to: "/capacity-planning",
  },
  {
    path: statergicplan,
    greenIcon: strategicplanning,
    title: "Strategic Planning",
    subtitle: "Forward planning of resources and demand.",
    to: "/strategic-planning",
  },
  {
    path: operationalplanning,
    greenIcon: operationalplanningG,
    title: "Operational Planning",
    subtitle: "Laying the ground work for daily operations.",
    to: "/operational-planning",
  },
  {
    path: jeopradyplan,
    greenIcon: jeomanagement,
    title: "Jeopardy Management",
    subtitle: "Empowering decisions with informed predictions.",
    to: "/jeopardy-management",
  },
  {
    path: routemap,
    greenIcon: routeplanning,
    title: "Route Planning",
    subtitle: "Charting the most optimized route for your operations.",
    to: "/route-mapping",
  },
  {
    path: scenariomodel,
    greenIcon: scenarioplanning,
    title: "Scenario Modelling",
    subtitle: "Navigating uncertainties with confidence.",
    to: "/scenario-modelling",
  },
];

export default function PlatformPopover() {
  const [imagesDatas, setImagesDatas] = useState(ImagesData);

  const MouseEnter = (index) => {
    setImagesDatas(
      imagesDatas.map((telecom: any, telindex: number) => {
        if (telindex === index) {
          return { ...telecom, selected: 1 };
        } else {
          return { ...telecom, selected: 0 };
        }
      })
    );
  };
  const MouseLeave = () => {
    setImagesDatas(
      imagesDatas.map((telecom: any, telindex: number) => {
        return { ...telecom, selected: 0 };
      })
    );
  };
  return (
    <>
      <div className="row radius-5 overflow-hidden bg-teal-50 popoverclass">
        <div className="w-20 mobile-cards-width d-flex flex-column align-items-start justify-content-between py-20 width-medium">
          <div className="dark-bg-color radius-10 p-15">
            <div>
              <p className="font-20 font-family-roboto fonts-800 line-23 text-white-color pb-2">
                Yantr.ai Platform
              </p>
              <p className="font-14 fonts-400 font-family-roboto-flex line-19 text-white-color pb-50 platform-subheading ">
                Streamline, Operationalize, Optimize and Visualize using
                Yantr.ai.
              </p>
            </div>
            <div className={`buttongroup`}>
              <div className="d-flex justify-content-start flex-gap-20 mt-24 wp-28">
                <Link to={"/platform"}>
                  <Button
                    textclass="font-16 fonts-500 align-items-center text-center line-19 p-17 font-family-roboto-flex justify-content-center"
                    className="wx-147 hx-40 text-color-success radius-5 d-flex align-items-center text-align-center justify-content-center"
                    text="View All"
                  />
                </Link>
              </div>
            </div>
          </div>
        </div>
        <div className="w-80 mobile-cards-width">
          <div className="row py-10 bg-teal-50 pb-10">
            {imagesDatas.map((val: any, index: any) => (
              <Link
                to={val.to}
                key={index}
                className="col-md-6 col-xl-4 d-flex flex-gap-5 text-white-co text-center py-20 text-black-95 pb-20"
                onMouseEnter={() => MouseEnter(index)}
                onMouseLeave={() => MouseLeave()}
              >
                <img
                  className="col-md-3 hx-60 wx-60"
                  src={val?.selected ? val?.path : val?.greenIcon}
                  alt={`svg images ${index + 1}`}
                />
                <div className="col-md-9 text-start pl-10">
                  <p className="text-white-co fonts-800 font-family-roboto font-18 text-start line-21 w-100 pb-10">
                    {val.title}
                  </p>
                  <p className="text-white-0 font-family-roboto fonts-400 font-16 line-20 w-100">
                    {val.subtitle}
                  </p>
                </div>
              </Link>
            ))}
          </div>
        </div>
      </div>
    </>
  );
}
